import { createFirebaseApp } from '@packages/web-shared';

export default createFirebaseApp();
